import React from 'react'
import { DateCard, SubHeading, Date, ContactContainer, TitleA, TextA, InnerContainer, TextContainer, ExperienceContainer, Job } from './experienceElements'
import { Icon } from '@iconify/react';
import { Img } from './experienceElements';
import entrust_image from '../../../images/entrust.svg';
import solace_image from '../../../images/solace.png';
import trend_image from '../../../images/trendmicro.png';

const Experience = () => {
  return (
    <>
    <ContactContainer>
      <TitleA>// experience</TitleA>
      <InnerContainer>
        <ExperienceContainer>
          <DateCard>
          <Date>JAN 2022 — SEP 2023</Date>
          <Img src={entrust_image} />
          </DateCard>
          <Job>
            <SubHeading>Full Stack Developer Co-op — Entrust</SubHeading>
            <TextContainer>
            Worked as a member of the Verification team, contributing to the Entrust cloud portal by enhancing UI, resolving bugs, and implementing features to streamline verification processes.
            </TextContainer>
            <ExperienceContainer>
              <Icon icon="logos:docker-icon" width="55"/>
              <Icon icon="devicon:spring" width="40" />
              <Icon icon="logos:java" width="30"/>
              <Icon icon="skill-icons:javascript" width="40"/>
              <Icon icon="simple-icons:microsoftsqlserver" color='#A51C1C' width="40"/>
            </ExperienceContainer>
          </Job>
        </ExperienceContainer>

        <ExperienceContainer>
          <DateCard>
          <Date>JAN 2024 — APR 2024</Date>
          <img src={solace_image} height={40} width={150} />
          </DateCard>
          <Job>
            <SubHeading>Software Engineer Co-op — Solace</SubHeading>
            <TextContainer>
            Worked as a member of the PubSub+ Insights team, transitioning multiple pages from Aurelia to React, and implementing front-end testing strategies with Jest, Testing Library, and Cypress to enhance the Insights section of the operation console UI.
            </TextContainer>
            <ExperienceContainer>
              <Icon icon="skill-icons:react-dark" width="55"/>
              <Icon icon="vscode-icons:file-type-typescript-official" width="55" />
              <Icon icon="skill-icons:jest" width="55" />
              <Icon icon="skill-icons:redux" width="55" />
              <Icon icon="logos:python" width="55"/>
              <Icon icon="vscode-icons:file-type-datadog" width="55"/>
            </ExperienceContainer>
          </Job>
        </ExperienceContainer>

        <ExperienceContainer>
          <DateCard>
          <Date>MAY 2024 — PRESENT</Date>
          <Img src={trend_image} />
          </DateCard>
          <Job>
            <SubHeading>Software Engineer Co-op — Trend Micro</SubHeading>
            <TextContainer>
            Working on the R&D Cloud One Workload Security Team, aiding in driving the containerization of services within Deep Security Manager to improve deployment efficiency and scalability in AWS using Docker, Kubernetes, and AWS services.
            </TextContainer>
            <ExperienceContainer>
              <Icon icon="skill-icons:aws-light" width="55"/>
              <Icon icon="skill-icons:kubernetes" width="55"/>
              <Icon icon="logos:docker-icon" width="64"/>
              <Icon icon="logos:java" width="40"/>
            </ExperienceContainer>
          </Job>
        </ExperienceContainer>
        
      </InnerContainer>
    </ContactContainer>
    </>
  )
}

export default Experience